import type { ReactNode } from 'react';
import React from 'react';

export function TableCellTypography({
  children,
  variant,
  color,
}: {
  readonly children: ReactNode;
  readonly variant?: string;
  readonly color?: string;
}) {
  return (
    <span
      className={`flex h-full items-center ${variant === 'subtitle2' ? 'font-semibold' : ''} ${color === 'textSecondary' ? 'text-secondary' : ''}`}
    >
      {children}
    </span>
  );
}
